import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {call, take, takeLatest, put, select} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import gql from 'graphql-tag';
import get from 'lodash.get';
import map from 'lodash.map';

import {init, result, mutation_result, mutation_error} from 'utils/graphql';

import {selectEnv} from 'reducers/env';

// Actions
const namespace = 'flows/deal/allocate';

export const DEAL_ALLOCATE_LOAD = defineAction('DEAL_ALLOCATE_LOAD', namespace);
export const dealAllocateLoad = createAction(DEAL_ALLOCATE_LOAD.ACTION);

export const DEAL_ALLOCATE_CHANGE = defineAction('DEAL_ALLOCATE_CHANGE', ['PERSIST'], namespace);
export const dealAllocateChange = createAction(DEAL_ALLOCATE_CHANGE.ACTION);
export const dealAllocatePersist = createAction(DEAL_ALLOCATE_CHANGE.PERSIST);

// Query
export const Qoperation = 'DealLeadInvestorsAllocate';
export const query = gql`
  query ${Qoperation}($dealId: ID!) {
    deal(id: $dealId) {
      id
      metrics {
        allocation
        flatFees
      }
      allocations {
        id
        self
        investment {
          amount
          allocated
        }
        owner {
          firstName
          lastName
          image
          self
        }
      }
    }
  }
`;

export const Moperation = 'AllocateDeal';
export const mutation = gql`
  mutation ${Moperation}($dealId: ID!, $allocations: [AllocationAmount]) {
    allocations: allocateDeal(id: $dealId, allocations: $allocations) {
      id
      investment {
        allocated
      }
    }
  }
`;
const transform = (allocated, id) => ({
  id,
  allocated,
});
export const saveProps = ({mutate, ownProps}) => () => mutate({
  variables: {
    dealId: ownProps.deal.id,
    allocations: map(ownProps.allocations, transform),
  },
});

// Deal Allocation Change Saga
export function* allocationChange({payload}) {
  yield put(dealAllocatePersist(payload));
}

// Load Lead Allocate Saga
export function* loadDealAllocateSaga() {
  // Wait for query to come back

  // Put response into store so that it can be updated
  const response = yield take(result(Qoperation));
  const allocations = get(response, 'result.data.deal.allocations');
  yield put(dealAllocateLoad({allocations}))

  // Handle allocation changes
  yield takeLatest(DEAL_ALLOCATE_CHANGE.ACTION, allocationChange);
}

// Load Lead Allocate Saga
export function* dealAllocatedSaga() {
  const env = yield select(selectEnv);

  if (env.web) {
    // Show toast
    const message = `Saved allocations`;
    yield call([toast, toast.success], message, {
      position: toast.POSITION.TOP_CENTER,
    });

  }
}

export function* dealAllocatedErrorSaga() {
  const env = yield select(selectEnv);

  if (env.web) {
    // Show toast
    const message = `Something went wrong saving`;
    yield call([toast, toast.error], message, {
      position: toast.POSITION.TOP_CENTER,
    });

  }
}

export function* sagas() {
  yield takeLatest(mutation_result(Moperation), dealAllocatedSaga);
  yield takeLatest(mutation_error(Moperation), dealAllocatedErrorSaga);
  yield takeLatest(init(Qoperation), loadDealAllocateSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/deal/allocate/index.js